import { DocumentSaleStatusEnum } from 'common/constants/enum';
import { PillStatus } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  value: string;
  style?: StyleObject | any;
}

export default function DocumentPillStatus(props: Props) {
  const { t } = useTranslation();
  const { value, style } = props;
  let status: 'blue' | 'brown' | 'green' | 'red' | 'yellow' | 'other';
  let text: string = '-';

  switch (value as DocumentSaleStatusEnum) {
    case DocumentSaleStatusEnum.Processed:
      status = 'yellow';
      text = t(`status:${value}`);
      break;
    case DocumentSaleStatusEnum.Submitted:
      status = 'green';
      text = t(`status:${value}`);

      break;
    case DocumentSaleStatusEnum.Finished:
      status = 'other';
      text = t(`status:${value}`);
      break;
    case DocumentSaleStatusEnum.Canceled:
      text = t(`status:${value}`);
      status = 'brown';
      break;
    case DocumentSaleStatusEnum.PendingRevertToProcessedApproval:
      text = t(`status:${value}`);
      status = 'brown';
      break;
    case DocumentSaleStatusEnum.PendingRevertToSubmittedApproval:
    case DocumentSaleStatusEnum.RevertToSubmittedDraft:
    case DocumentSaleStatusEnum.RevertToProcessedDraft:
      text = t(`status:${value}`);
      status = 'brown';
      break;
    default:
      status = 'other';
      break;
  }
  return <PillStatus $style={style} status={status} children={text} />;
}
